/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import YouTube from 'react-youtube';
// import ReactPlayer from 'react-player';
/* Internal Imports */
/* Components */
import MidContainer from '@Layout/MidContainer';
import LiteYouTubeEmbed from '@components/Embeds/YoutubeEmbed';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { getEmbedUrl } from '@components/Utility/utils';
import config from '@config';

/* Services */
/* Styles */
import styles from '@lb/components/Embeds/RitualEmbed.module.css';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * @param {object} sectionContent - Data for Section
 * @param margin
 * @param width
 * @param pxBase
 * @returns {ReactElement} MediaEmbed component
 */

const RitualEmbed = ({ sectionContent, margin, width, pageData }) => {
  // const [vidVis, setVidVis] = useState(false);
  const [opts, setOpts] = useState({});
  const { isOpen, onOpen, onClose } = useDisclosure();
  useEffect(() => {
    setOpts({
      height: document.getElementById('msr-vid')?.clientHeight,
      // height: '315',
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
    });
  }, [global?.window]);

  const onReady = event => {
    event.target.playVideo();
  };
  let url = sectionContent?.embedUrl || sectionContent?.url || sectionContent?.video?.url;
  let splitUrl = url?.split('&');
  url = splitUrl[0];
  if (sectionContent?.image?.url || sectionContent?.thumbnailUrl || sectionContent?.thumbnailDesktopImage.url) {
    return (
      <>
        {/* {sectionContent.style === 'lb-inline-video' ? ( */}
        <MidContainer w={width || '100%'}>
          <Box
            width="100%"
            maxW="1330px"
            margin="0 auto"
            height={{ base: '335.35px', md: '482px' }}
            mb={{ base: '40px', md: '40px' }}
          >
            <Box
              pos="relative"
              // display={vidVis ? 'none' : 'block'}
              height="100%"
              backgroundImage={{
                base:
                  pageData?.videoDesktopThumbnail?.url ||
                  sectionContent?.thumbnailUrl ||
                  sectionContent?.image?.url || sectionContent?.thumbnailMobileImage.url,
                md:
                  pageData?.videoDesktopThumbnail?.url ||
                  sectionContent?.thumbnailUrl ||
                  sectionContent?.image?.url || sectionContent?.thumbnailDesktopImage?.url,
              }}
              backgroundSize="cover"
              backgroundPosition="center"
              backgroundRepeat="no-repeat"
            >
              <Box
                pos="absolute"
                top="24px"
                bottom="-32px"
                height={{ base: '337px', md: '482px' }}
                background="linear-gradient(90deg, rgba(158, 103, 20, 0.62) 36%, rgba(217, 217, 217, 0) 91.62%)"
                right={{ base: '10%', md: '40%' }}
                left="0"
                display="flex"
                justifyContent={{ base: 'flex-end', md: 'flex-end' }}
              >
                <Flex
                  display="flex"
                  flexDir={{ base: 'column', md: 'row' }}
                  justifyContent={{ base: 'flex-start', md: 'flex-end' }}
                  flexDirection={{ base: 'column', md: 'row' }}
                  alignItems="center"
                  gridGap={{ base: '30px' }}
                  height="auto"
                  w="100%"
                  minH={{ base: '180px', md: '220px' }}
                  mt="auto"
                >
                  <Box
                    pr="10%"
                    alignSelf="center"
                    order={{ base: '1 !important', md: '2 !important' }}
                    w={{ base: '57.12px', md: 'auto' }}
                    h={{ base: '57.12px', md: 'auto' }}
                    marginTop={{ md: '-279px', base: '-24px' }}
                  >
                    <Box
                      // display={{ base: 'none', md: 'block' }}
                      w={{ base: '57px', md: '104px' }}
                      minH={{ base: '57px', md: '104px' }}
                      height={{ base: '57px', md: '104px' }}
                      // onClick={e => setVidVis(!vidVis)}
                      onClick={onOpen}
                      cursor="pointer"
                    >
                      <LazyLoadImageComponent
                        objectFit="contain"
                        w={{ base: '57px', md: '104px' }}
                        minH={{ base: '57px', md: '104px' }}
                        height={{ base: '57px', md: '104px' }}
                        src={`${config.imgPath}/d/46272/1681964046-icon.svg`}
                      />
                    </Box>
                  </Box>
                </Flex>
              </Box>
              <Box 
                pos="absolute"
                bottom="10px"
                lineHeight="100%"
                left={{ base: '5%', md: '10%' }}
                fontFamily="FedraSerifDisplay" fontSize={{base:'46px', md:'80px'}} color="#F3F0E6">{sectionContent.title}</Box>
            </Box>

            <Modal
              isOpen={isOpen}
              onClose={onClose}
              size="6xl"
              isCentered
              closeOnOverlayClick={false}
            >
              <ModalOverlay bg="rgba(0, 0, 0, 0.7)" />
              <ModalContent
                p={0}
                m="0"
                bg={{ base: '#000000' }}
                // transform={{ base: 'rotate(270deg)', md: 'none' }}
                maxW={{ base: 'auto', md: '992px' }}
                maxH={{ base: '357px', md: '587px' }}
              >
                <ModalCloseButton
                  _hover={{ bg: '#fff', color: '#000' }}
                  _active={{ bg: '#fff', color: '#000' }}
                  _focus={{ bg: '#fff', color: '#000' }}
                  zIndex="20"
                  top="-5px"
                  bg="#fff"
                  color="#000"
                  right="-5px"
                  rounded="full"
                  className={styles.closeButton}
                />
                <ModalBody p={0} m="0" w="100%" position="relative">
                  <Box
                    pos={{ base: 'static', md: 'static' }}
                    left="50%"
                    right="50%"
                    // transform={{ md: 'none', base: 'translate(-50%, -50%)' }}
                    display={{ base: 'flex', md: 'block' }}
                    justifyContent={{ base: 'center' }}
                    alignItems={{ base: 'center' }}
                  >
                    <Box
                      bg="#FFFFFF"
                      onClick={onClose}
                      w="32px"
                      h="32px"
                      rounded="full"
                      _hover={{ bg: '#ffffff' }}
                      display={{ base: 'grid', md: 'none' }}
                      placeItems="center"
                      pos="absolute"
                      top="-145px"
                      left="-185px"
                      fontFamily="FedraSansStd-Book"
                      zIndex="10"
                      cursor="pointer"
                      color="black"
                    >
                      x
                    </Box>
                    <YouTube
                      videoId={getEmbedUrl(url)}
                      onReady={onReady}
                      opts={opts}
                      loading="lazy"
                      className={styles.RitualEmbed}
                    />{' '}
                  </Box>
                  {/* </Box> */}
                </ModalBody>
              </ModalContent>
            </Modal>
          </Box>
        </MidContainer>
      </>
    );
  }

  let pb = '56.25%';
  if (sectionContent?.source === 'soundcloud') {
    pb = '17%';
  } else {
    pb = '22%';
  }

  return sectionContent?.embedUrl || sectionContent?.url ? (
    <MidContainer w={width || '755px'}>
      <Box
        className="msr-vid"
        position="relative"
        display="block"
        width={width}
        pb={pb}
        height="auto"
        m={margin || '30px auto'}
        px="{{ base: pxBase || '15px', md: 0 }}"
      // {...props}
      >
        {sectionContent?.source === 'youtube' ||
          (sectionContent?.embedUrl?.indexOf('youtube.com') > -1 && (
            <LiteYouTubeEmbed
              id={getEmbedUrl(sectionContent?.embedUrl)}
              embedUrl={getEmbedUrl(sectionContent?.embedUrl)}
              cookie
            />
          ))}

        {/* {sectionContent?.source === 'facebook' && (
          <FacebookPlayer
            className="fb-player"
            // videoId="2749633985172495"
            videoId={sectionContent?.embedUrl}
            appId="1503437569957732"
            // width={500}
            // height="auto"
            allowfullscreen={false}
            autoplay={true}
          />
        )} */}

        {sectionContent?.source !== 'facebook' &&
          sectionContent?.source !== 'youtube' && (
            <Box
              as="iframe"
              width="100%"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
              src={getEmbedUrl(sectionContent?.embedUrl)}
            />
          )}
      </Box>
      <style>
        {`.fb-player {
          width:100%;
          height: auto;
          max-height: 600px;
        }`}
      </style>
    </MidContainer>
  ) : null;
};

export default RitualEmbed;
